import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { XIcon, ShieldCheckIcon, TruckIcon, FileTextIcon, SparklesIcon } from './Icons';
import './LegalPage.css';

function LegalPage({ isOpen, policyType, onClose }) {
    const { t } = useTranslation();
    const contentRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            if (contentRef.current) {
                contentRef.current.scrollTop = 0;
            }
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen || !policyType) return null;

    const getIcon = () => {
        switch (policyType) {
            case 'privacy': return <ShieldCheckIcon />;
            case 'shipping': return <TruckIcon />;
            case 'terms': return <FileTextIcon />;
            default: return <SparklesIcon />;
        }
    };

    // Format content: split by newlines, wrap in p tags, and bold the bullet points
    const formatContent = (content) => {
        return content.split('\n').map((paragraph, index) => {
            if (!paragraph.trim()) return null;

            // Check if paragraph is a numbered list item like "1. Title: text"
            const ruleMatch = paragraph.match(/^(\d+\.\s+)([^:]+:)(.*)$/);

            if (ruleMatch) {
                return (
                    <div key={index} className="policy-rule">
                        <div className="rule-number">{ruleMatch[1].replace('.', '')}</div>
                        <div className="rule-content">
                            <strong>{ruleMatch[2]}</strong>
                            <p>{ruleMatch[3]}</p>
                        </div>
                    </div>
                );
            }

            return <p key={index} className="policy-intro">{paragraph}</p>;
        });
    };

    return (
        <div className={`legal-modal-overlay ${isOpen ? 'is-open' : ''}`} onClick={onClose}>
            {/* Ambient Background Glows */}
            <div className="modal-glow glow-1"></div>
            <div className="modal-glow glow-2"></div>

            <div className="legal-modal-container" onClick={(e) => e.stopPropagation()}>
                {/* Lateral / Top Header Section */}
                <div className="legal-modal-header">
                    <button className="legal-modal-close" onClick={onClose} aria-label="Close modal">
                        <XIcon />
                    </button>
                    <div className="header-icon-wrapper">
                        {getIcon()}
                    </div>
                    <div>
                        <span className="legal-subtitle">VITA<span style={{ color: '#fff' }}>PLEX</span> LEGAL</span>
                        <h1 className="legal-title">{t(`policy.${policyType}.title`)}</h1>
                    </div>
                </div>

                {/* Content Section */}
                <div className="legal-modal-body" ref={contentRef}>
                    <div className="legal-content-inner">
                        {formatContent(t(`policy.${policyType}.content`))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LegalPage;
